import { OrderStatus } from '../../types';

/**
 * Returns a Unicode icon/emoji for the order status
 * These represent all order statuses in the workflow
 */
export const getOrderStatusIcon = (status: OrderStatus): string => {
  switch (status) {
    case OrderStatus.DRAFT:
      return '📝'; // Draft/Note icon
    case OrderStatus.CHECKED_OUT:
      return '🛒'; // Shopping cart/Checked out icon
    case OrderStatus.IN_QUEUE:
      return '📋'; // Queue/Clipboard icon
    case OrderStatus.SAW:
      return '🪚'; // Industrial saw icon
    case OrderStatus.WELD:
      return '⚡'; // Weld/Spark icon
    case OrderStatus.PAINT:
      return '🎨'; // Paint icon
    case OrderStatus.ON_HOLD:
      return '⏸️'; // Pause icon
    case OrderStatus.COMPLETE:
      return '🎉'; // Celebration/Complete icon
    case OrderStatus.READY_FOR_PICKUP:
      return '✅'; // Checkmark/Pickup icon
    case OrderStatus.SHIPPED:
      return '🚚'; // Truck/Shipped icon
    default:
      return '📦'; // Default package icon
  }
};

/**
 * Returns all status icons for display in filters/popup
 * Only includes statuses that should appear on the dashboard calendar
 * Ordered by status workflow: Checked Out → In Queue → Saw → Weld → Paint → On Hold → Complete → Ready for Pickup → Shipped
 */
export const getAllStatusIcons = (): Array<{
  status: OrderStatus;
  icon: string;
  label: string;
}> => {
  return [
    {
      status: OrderStatus.CHECKED_OUT,
      icon: getOrderStatusIcon(OrderStatus.CHECKED_OUT),
      label: 'Checked Out',
    },
    {
      status: OrderStatus.IN_QUEUE,
      icon: getOrderStatusIcon(OrderStatus.IN_QUEUE),
      label: 'In Queue',
    },
    { status: OrderStatus.SAW, icon: getOrderStatusIcon(OrderStatus.SAW), label: 'Saw' },
    { status: OrderStatus.WELD, icon: getOrderStatusIcon(OrderStatus.WELD), label: 'Weld' },
    { status: OrderStatus.PAINT, icon: getOrderStatusIcon(OrderStatus.PAINT), label: 'Paint' },
    {
      status: OrderStatus.ON_HOLD,
      icon: getOrderStatusIcon(OrderStatus.ON_HOLD),
      label: 'On Hold',
    },
    {
      status: OrderStatus.COMPLETE,
      icon: getOrderStatusIcon(OrderStatus.COMPLETE),
      label: 'Completed',
    },
    {
      status: OrderStatus.READY_FOR_PICKUP,
      icon: getOrderStatusIcon(OrderStatus.READY_FOR_PICKUP),
      label: 'Ready for Pickup',
    },
    {
      status: OrderStatus.SHIPPED,
      icon: getOrderStatusIcon(OrderStatus.SHIPPED),
      label: 'Shipped',
    },
  ];
};
